var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 24,
    viewBox: "0 0 34 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4922 3.8975C32.1161 2.48127 31.0079 1.36589 29.6009 0.987375C27.0504 0.299561 16.8236 0.299561 16.8236 0.299561C16.8236 0.299561 6.5968 0.299561 4.04632 0.987375C2.63926 1.36595 1.53107 2.48127 1.15494 3.8975C0.471558 6.4645 0.471558 11.8203 0.471558 11.8203C0.471558 11.8203 0.471558 17.1761 1.15494 19.7431C1.53107 21.1593 2.63926 22.2282 4.04632 22.6068C6.5968 23.2946 16.8236 23.2946 16.8236 23.2946C16.8236 23.2946 27.0504 23.2946 29.6009 22.6068C31.0079 22.2282 32.1161 21.1593 32.4922 19.7431C33.1756 17.1761 33.1756 11.8203 33.1756 11.8203C33.1756 11.8203 33.1756 6.4645 32.4922 3.8975V3.8975ZM13.4788 16.683V6.95764L22.0265 11.8204L13.4788 16.683V16.683Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.e2142d98a52786c6fa53d29d2a407133.svg";
export { ForwardRef as ReactComponent };